import {
    INT_REGEX,
    IntegerSchemaValues,
} from '../../../components/models/Integer/consts'

function isValidEmptyIntegerValue(value: any) {
    return value === 'null' || value == null
}

const parseIntegerValue = (val: any): bigint | null => {
    if (val === 'null' || val == null || val === '') {
        return null
    }

    const strVal = String(val).trim()

    if (strVal.includes('.')) {
        return null
    }

    if (!INT_REGEX.test(strVal)) {
        return null
    }

    try {
        return BigInt(strVal)
    } catch {
        return null
    }
}

export const getIntegerSchema = (inputString: any, schema: any) => {
    const baseTest = (
        name: string,
        message: string,
        testFn: (n: bigint) => boolean
    ) =>
        inputString.test(name, message, (val: any) => {
            if (!schema.is_required && isValidEmptyIntegerValue(val)) {
                return true
            }

            const parsedInt = parseIntegerValue(val)

            if (parsedInt === null) {
                return false
            }

            try {
                return testFn(parsedInt)
            } catch {
                return false
            }
        })

    if (typeof schema.greater_or_equal === 'string') {
        inputString = baseTest(
            IntegerSchemaValues.GREATER_OR_EQUAL,
            `Must be ≥ ${schema.greater_or_equal}`,
            (n) => {
                try {
                    return n >= BigInt(schema.greater_or_equal)
                } catch {
                    return false
                }
            }
        )
    }

    if (typeof schema.greater_than === 'string') {
        inputString = baseTest(
            IntegerSchemaValues.GREATER_THAN,
            `Must be > ${schema.greater_than}`,
            (n) => {
                try {
                    return n > BigInt(schema.greater_than)
                } catch {
                    return false
                }
            }
        )
    }

    if (typeof schema.less_or_equal === 'string') {
        inputString = baseTest(
            IntegerSchemaValues.LESS_OR_EQUAL,
            `Must be ≤ ${schema.less_or_equal}`,
            (n) => {
                try {
                    return n <= BigInt(schema.less_or_equal)
                } catch {
                    return false
                }
            }
        )
    }

    if (typeof schema.less_than === 'string') {
        inputString = baseTest(
            IntegerSchemaValues.LESS_THAN,
            `Must be < ${schema.less_than}`,
            (n) => {
                try {
                    return n < BigInt(schema.less_than)
                } catch {
                    return false
                }
            }
        )
    }

    if (schema.is_required) {
        inputString = inputString
            .matches(INT_REGEX, 'Must be a valid integer')
            .required('This field is required')
    } else {
        inputString = inputString
            .transform((_: any, val: any) => {
                if (val === '' || val === 'null' || val == null) {
                    return null
                }
                return String(val)
            })
            .nullable()
            .notRequired()
            .test(
                'valid-integer-format',
                'Must be a valid integer',
                (val: any) => {
                    if (val == null || val === 'null') {
                        return true
                    }
                    return INT_REGEX.test(String(val))
                }
            )
    }

    return inputString
}
